import { Component } from '@angular/core';

@Component({
    selector: 'pp-notification-new-point-mention',
    templateUrl: './notification-new-point-mention.component.html',
    styleUrls: ['../notification.component.scss'],
    standalone: false
})
export class NotificationNewPointMentionComponent {
  constructor() {}
}
